export interface RecentHovCoreRateClock {
  nowMs(): number;
  advanceByGameDtSeconds(dtSeconds: number): number;
  advanceByElapsedMs(elapsedMs: number): number;
}

export function createRecentHovCoreRateClock(
  initialObservedAtMs: number,
): RecentHovCoreRateClock {
  assertFiniteMilliseconds(initialObservedAtMs, "initialObservedAtMs");

  let observedAtMs = initialObservedAtMs;

  const advanceByElapsedMs = (elapsedMs: number): number => {
    if (!Number.isFinite(elapsedMs) || elapsedMs <= 0) {
      return observedAtMs;
    }
    const nextObservedAtMs = observedAtMs + elapsedMs;
    if (!Number.isFinite(nextObservedAtMs)) {
      return observedAtMs;
    }
    observedAtMs = nextObservedAtMs;
    return observedAtMs;
  };

  return {
    nowMs(): number {
      return observedAtMs;
    },

    advanceByGameDtSeconds(dtSeconds: number): number {
      return advanceByElapsedMs(dtSeconds * 1000);
    },

    advanceByElapsedMs,
  };
}

function assertFiniteMilliseconds(value: number, name: string): void {
  if (!Number.isFinite(value)) {
    throw new Error(`${name} must be a finite millisecond value`);
  }
}
